const numericAmount = (value) => Number(value ?? 0);

export const calculatePaymentTotal = (payment) => {
  return numericAmount(payment?.payment_confirm_amount) +
    numericAmount(payment?.transfer_fee) +
    numericAmount(payment?.other_deduction_amount);
};

// 新APIの確定値を優先し、旧APIでは取得できた3項目から合計する。
export const getSettledAmount = (payment) => {
  return payment?.settled_amount ?? calculatePaymentTotal(payment);
};

export const hasOtherDeduction = (payment) => numericAmount(payment.other_deduction_amount) !== 0;

export const paymentAmountsError = (payment) => {
  if (payment.payment_confirm_amount == null || String(payment.payment_confirm_amount).trim() === '') {
    return '入金額を入力してください。';
  }

  const amountFields = [
    ['入金額', payment.payment_confirm_amount, false],
    ['振込手数料', payment.transfer_fee, false],
    ['その他控除額', payment.other_deduction_amount, true]
  ];
  for (const [label, value, allowNegative] of amountFields) {
    const amount = numericAmount(value);
    if (!Number.isInteger(amount) || (!allowNegative && amount < 0)) {
      return `${label}は${allowNegative ? '' : '0円以上の'}整数で入力してください。`;
    }
  }
  return '';
};
